import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_arrow_left",
  "use": "icon-icon_general_arrow_left-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" overflow=\"visible\" id=\"icon-icon_general_arrow_left\">\n<g>\n\t<polygon points=\"30.2000008,41.7999992 12.5,24 30.2000008,6.1999998 33.7999992,9.8000002 19.5,24\n\t\t33.7999992,38.2000008 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol